module.exports = __webpack_public_path__ + "27d0732bb3f4b4bb8942ce0a59b1ab99.png";